<div class="button-container" [class]="'button-container-' + size">
    @if (!loading) {
        <button
            type="button"
            [class]="'btn btn-' + size"
            [class.btn-primary]="primary"
            [class.btn-default]="!primary"
            [class.btn-notification]="notification"
            [disabled]="loading || disabled"
            (click)="click()"
        >
            @if (notification) {
                <span class="btn-notification-label">{{ notificationLabel }}</span>
            }
            {{ label | translate }}
        </button>
    }
    @if (loading) {
        <div class="loading-container absolute-centering">
            <span class="spinner absolute-centering zoom-in" [class]="'spinner-' + size"></span>
            <span class="loading-text absolute-centering zoom-in">{{ loadingText | translate }}</span>
        </div>
    }
</div>
